<script setup>
import { computed } from 'vue'

import Button from "@/common/Button.vue"

import { usePageEditorStore } from '@/stores/pageEditor'

const props = defineProps({
    activeTabPropName: String,
    iconClass: String,
    tabName: String,
    borderClassName: String
})

const pageEditorStore = usePageEditorStore()

const activeTab = computed({
    get() {
        return pageEditorStore[props.activeTabPropName]
    },
    set(newValue) {
        pageEditorStore[props.activeTabPropName] = newValue
    }
})

const isActive = computed(() => activeTab.value === props.tabName)
const classNames = computed(() => isActive.value ? 'active border-top border-bottom' : props.borderClassName)

const onClick = () => {
    activeTab.value = activeTab.value === props.tabName ? '' : props.tabName
}
</script>

<template>
    <Button @click="onClick" class="btn-sm rounded-0" :default-class="'bg-body-tertiary'"
            :class="classNames" :active-class="''" :active-value="isActive" :title="tabName">
        <i class="bi" :class="iconClass"/>
    </Button>
</template>

<style scoped>
.active {
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: var(--bs-border-color) !important;
}
</style>